import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { t } from 'i18next';

export const useGetFundingDirectionsDisplayOrder = () => {
  const { t, i18n } = useTranslation();

  return useMemo(() => {
    const FUNDING_NEEDS_DISPLAY_ORDER = [
      t('executiveSummary.financialNeeds.researchCost'),
      t('executiveSummary.financialNeeds.marketingCost'),
      t('executiveSummary.financialNeeds.workingCapitalCost'),
      t('executiveSummary.financialNeeds.equipmentCost'),
      t('executiveSummary.financialNeeds.constructionCost'),
      t('executiveSummary.financialNeeds.otherCost'),
    ];
    return FUNDING_NEEDS_DISPLAY_ORDER;
  }, [t, i18n]);
};

export const FUNDING_NEEDS_DISPLAY_ORDER = [
  t('executiveSummary.financialNeeds.researchCost'),
  t('executiveSummary.financialNeeds.marketingCost'),
  t('executiveSummary.financialNeeds.workingCapitalCost'),
  t('executiveSummary.financialNeeds.equipmentCost'),
  t('executiveSummary.financialNeeds.constructionCost'),
  t('executiveSummary.financialNeeds.otherCost'),
];
